/**
 * Base URL for all static images.
 * Set NEXT_PUBLIC_IMAGE_BASE_URL in .env to use a CDN/external domain.
 * Examples:
 *   - Local dev: "" (empty, serves from localhost)
 *   - Testing: "https://test-bookitplease.optimiser.site"
 *   - Production: "https://bookitplease.com"
 */
export const IMG =
  process.env.NEXT_PUBLIC_IMAGE_BASE_URL || 'https://www.bookitplease.com';
